export default "__VITE_ASSET__BUqKS9BN__"